import React from "react";
import { HOTKEYS_SCOPES } from "@hooks/keyboard/useKeyboardCommand";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { HStack } from "@design-system/HStack/HStack";

interface Props {
    valid: boolean;
    loading?: boolean;
    onCancel(): void;
}

export const UpdateProfileFormFooter: React.FC<Props> = ({
    loading,
    valid,
    onCancel,
}) => (
    <HStack as="footer" justify="end" gap={12}>
        <Button variant="secondary" size="xl" type="button" onClick={onCancel}>
            Cancel
        </Button>

        <ButtonWithLoader
            variant="primary"
            size="xl"
            disabled={!valid}
            loading={!!loading}
            type="submit"
            hotKey="mod+enter"
            hotKeyOptions={{
                description: "Next",
                preventDefault: true,
                enableOnFormTags: true,
                scopes: [HOTKEYS_SCOPES.SETTINGS_MODAL],
            }}
        >
            Next
        </ButtonWithLoader>
    </HStack>
);
